import React, { FC } from 'react';

type FileIconProps = {
  className?: string;
};

import './FileIcon.scss';

const FileIcon: FC<FileIconProps> = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M19,8.41V20a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V4A1,1,0,0,1,6,3h7.59a1,1,0,0,1,.7.29l4.42,4.42A1,1,0,0,1,19,8.41Z" />
  </svg>
);

export default FileIcon;
